import { iaRa } from 'lib/helpers/utility';

export const buildProviderRows = (entries, practitioners) => {
  return iaRa(entries)
    .map((entry) => {
      const practitioner = practitioners.find((p) => p.value === entry.provider_id);
      if (!practitioner) return null;
      return { ...practitioner, state_ids: iaRa(entry.state_ids) };
    })
    .filter(Boolean);
};

export const buildOppositeStateMap = (in_network_providers, out_of_network_providers) => {
  const buildMap = (entries) => {
    const map = new Map();
    iaRa(entries).forEach((entry) => {
      map.set(entry.provider_id, iaRa(entry.state_ids));
    });
    return map;
  };

  return {
    in_network_providers: buildMap(out_of_network_providers),
    out_of_network_providers: buildMap(in_network_providers)
  };
};
